import React, {useEffect} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ContentDispatch} from 'framework';
import REST from 'go/requests/rest';

/**
 *
 * @param {*} props
 * @param {Object} props.data - Data from redux store (usually an entity loaded for the page)
 * @param {Object} props.contents - Contents from config, used to render any child components (not common)
 * @param {function} props.saveEntitySessionData - Function used to save the API response data to context
 * @param {string} props.contextPathToSave - The context path to save the API response data to
 * @param {Object} props.apiConfig - API config containig service, action, and params
 * @param {string[]} props.reloadOnPaths - List of redux store paths to watch for changes, changes trigger a reload
 * @param {*} restProps - All other props inherently passed from Config (context, etc.)
 */
export const RestAPICallListener = ({
  data,
  contents,
  saveEntitySessionData,
  contextPathToSave,
  apiConfig,
  reloadOnPaths,
  excludeLoading,
  staticData,
  ...restProps
}) => {
  // Combine redux store data (usually the entity loaded for a page) with the rest of the props (context, etc) to grab data from
  const lookupData = {...restProps, ...data};
  // Grab the values corresponding to the reloadPaths from the config
  const reloadOnValues = _.map(reloadOnPaths, (path) => _.get(lookupData, path, path));

  useEffect(() => {
    if (contextPathToSave && apiConfig) {
      const {service, action, params} = apiConfig;
      if (service && action && params) {
        const {service, action, params} = apiConfig;

        const args = {};
        _.each(params, (value, key) => {
          args[key] = _.get(lookupData, value, value);
        });

        /* This will dynamically call ANY rest endpoint we have with one caveat: 
            the function must have destructured parameters */
        REST[service][action]({...args})
          .then(REST.handler.handleResponse)
          .then((res) => {
            if (staticData) {
              res = [...staticData, ...res];
            }
            excludeLoading
              ? saveEntitySessionData(contextPathToSave, res)
              : saveEntitySessionData(contextPathToSave, {...res, loading: false});
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
    // The second argument of useEffect here is used to reload this data by watching all of the reloadValues for any changes
  }, [...reloadOnValues]);

  // This render method is really only here to allow for rendering direct children of this listener in config, if ever needed.
  return (
    <>
      {_.map(contents, (entry, index) => {
        return <ContentDispatch config={entry} key={entry.title} />;
      })}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, null)(connectDynamic(RestAPICallListener));
